import React from 'react';
import styled from '@benzinga/themetron';
import { Button } from '@benzinga/core-ui';
import { SmartLink } from '@benzinga/analytics';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneFlip } from '@fortawesome/pro-solid-svg-icons/faPhoneFlip';
import { sanitizeHTML } from '@benzinga/frontend-utils';
export interface ProductCallNowProps {
  buttonText?: string;
  phone: string;
  label: string;
}

export const ProductCallNow: React.FC<ProductCallNowProps> = ({ buttonText, label, phone }) => {
  return (
    <ProductCallNowContainer>
      <SmartLink className="cta-link-button" href={`tel:${phone}`} label={label || 'Call Now'}>
        <Button variant="cta">
          <span
            className="call-now-label"
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(buttonText ?? '  Call Now  ') }}
          />
          <FontAwesomeIcon icon={faPhoneFlip} />
        </Button>
      </SmartLink>
    </ProductCallNowContainer>
  );
};

const ProductCallNowContainer = styled.div`
  align-items: center;
  text-align: center;
  margin-top: 16px;
  .call-now-label {
    margin-right: 6px;
  }
`;
